module.exports = __webpack_public_path__ + "static/media/imagem29.3e415ca6.jpeg";